var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowsDotnet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:#14559A;}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:#3092C4;}\r\n\t.st5{fill:#1969BC;}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{fill:url(#SVGID_5_);}\r\n\t.st8{fill:url(#SVGID_6_);}\r\n\t.st9{fill:#2B74B1;}\r\n\t.st10{fill:#125A9E;}\r\n\t.st11{fill:url(#SVGID_7_);}\r\n\t.st12{fill:url(#SVGID_8_);}\r\n\t.st13{fill:#0D82CA;}\r\n\t.st14{fill:url(#SVGID_9_);}\r\n\t.st15{fill:#127BCA;}\r\n\t.st16{fill:url(#SVGID_10_);}\r\n\t.st17{fill:url(#SVGID_11_);}\r\n\t.st18{fill:#05A1E6;}\r\n\t.st19{fill:url(#SVGID_12_);}\r\n\t.st20{fill:url(#SVGID_13_);}\r\n\t.st21{fill:url(#SVGID_14_);}\r\n\t.st22{fill:#079AE1;}\r\n\t.st23{fill:#1E5CB3;}\r\n\t.st24{fill:#1D60B5;}\r\n\t.st25{fill:#175FAB;}\r\n\t.st26{fill:url(#SVGID_15_);}\r\n\t.st27{fill:#7DCBEC;}\r\n\t.st28{fill:#5EC5ED;}\r\n\t.st29{fill:url(#SVGID_16_);}\r\n\t.st30{fill:url(#SVGID_17_);}\r\n\t.st31{fill:url(#SVGID_18_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.810127, 0.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -441.2719,
    y1: 5.4698,
    x2: -441.2719,
    y2: 5.7565,
    gradientTransform: "matrix(45.6076 0 0 81.335 20146.6035 -430.6219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0994DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#66CEF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#66CEF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#127BCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#127BCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#127BCA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,18c1.8,5.4,2.4,15,7.6,15l0,0c0.4,0,0.8,0,1.2-0.1l0,0c-4.7-1.1-5.2-10.6-8.1-15.5l0,0 C17.2,17.5,17,17.7,16.8,18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -441.7202,
    y1: 5.3587,
    x2: -441.7202,
    y2: 5.6455,
    gradientTransform: "matrix(47.8692 0 0 83.4083 21166.9453 -433.2969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E76BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#36AEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#36AEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#00ADEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#00ADEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00ADEF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.5,17.3c2.9,4.9,3.4,14.4,8.1,15.5l0,0c0.4-0.1,0.7-0.2,1.1-0.3l0,0c-4.2-2-5.4-11.3-8.6-15.7l0,0 C17.9,17,17.7,17.1,17.5,17.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.6,14.4c-0.4,0-0.8,0-1.2,0.1c-1,0.2-2.1,0.6-3.2,1.3c0.3,0.3,0.6,0.6,0.8,1c1.1-0.9,2.2-1.6,3.2-2 c0.4-0.1,0.8-0.3,1.2-0.3C22.2,14.4,21.9,14.4,21.6,14.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -441.7704,
    y1: 5.6594,
    x2: -441.7704,
    y2: 5.4343,
    gradientTransform: "matrix(45.4522 0 0 84.5 20106.4395 -445.8086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C63B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#33BDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#33BDF2",
      stopOpacity: 0.4196
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,30.6c0.4-0.3,0.9-0.7,1.3-1.1c-1.8-5.4-2.4-15.1-7.6-15.1c-0.4,0-0.7,0-1.1,0.1C27.2,15.7,27.8,26,30,30.6 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.5,14.5c-0.3-0.1-0.6-0.1-0.9-0.1h2C23.3,14.4,22.9,14.4,22.5,14.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.9,31.8c-0.2-0.2-0.4-0.4-0.6-0.6c-0.9,0.6-1.7,1.1-2.6,1.4c0.3,0.2,0.6,0.3,1,0.3C28,33,28.2,33,28.5,33 c1,0,1.7-0.1,2.4-0.4C30.5,32.3,30.2,32.1,29.9,31.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -441.5827,
    y1: 5.2718,
    x2: -441.5827,
    y2: 5.5585,
    gradientTransform: "matrix(45.0105 0 0 86.5982 19901.5605 -445.2608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#166AB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#36AEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#36AEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#0798DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#0798DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0798DD"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.3,14.8c4.2,2.2,4.6,12.2,8,16.3l0,0c0.2-0.2,0.5-0.3,0.7-0.5l0,0c-2.1-4.7-2.7-15-7.4-16.1l0,0 C22.1,14.6,21.7,14.7,21.3,14.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -443.1648,
    y1: 4.9401,
    x2: -443.1648,
    y2: 5.2269,
    gradientTransform: "matrix(58.3509 0 0 92.0822 25882.8145 -443.5112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#1487CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#1487CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7802,
    style: {
      stopColor: "#165197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7802,
    style: {
      stopColor: "#165197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#165197"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M18.1,16.8c3.2,4.4,4.4,13.7,8.6,15.7l0,0c0.9-0.3,1.7-0.8,2.6-1.4l0,0c-3.4-4.1-3.7-14.1-8-16.3l0,0 C20.2,15.2,19.1,15.9,18.1,16.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -429.4305,
    y1: 14.6902,
    x2: -429.2382,
    y2: 14.6902,
    gradientTransform: "matrix(19.4176 0 0 30.9219 8351.6279 -434.7998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33BDF2",
      stopOpacity: 0.698
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1DACD8"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M14.7,17.8c-0.5,1.2-1,2.7-1.7,4.6c1.2-1.8,2.5-3.3,3.7-4.5c-0.2-0.5-0.4-1-0.6-1.4 C15.7,16.9,15.2,17.3,14.7,17.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.7,16.2c-0.1,0.1-0.3,0.2-0.5,0.3c0.2,0.4,0.4,0.9,0.6,1.4c0.2-0.2,0.4-0.4,0.7-0.6 C17.2,16.9,17,16.5,16.7,16.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M17.2,15.8c-0.1,0.1-0.3,0.3-0.5,0.4c0.3,0.3,0.5,0.7,0.8,1.1c0.2-0.2,0.4-0.4,0.6-0.5 C17.8,16.4,17.5,16.1,17.2,15.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -445.655,
    y1: 4.8636,
    x2: -445.655,
    y2: 4.6758,
    gradientTransform: "matrix(79.1425 0 0 98.6787 35311.4023 -448.0057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#136AB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#59CAF5",
      stopOpacity: 0.549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59CAF5",
      stopOpacity: 0.2353
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M46.1,14c-2.4,9.2-7.4,16.6-11.6,18.5l0,0c-0.1,0-0.2,0.1-0.2,0.1l0,0c0,0,0,0-0.1,0l0,0h-0.1l0,0 c0,0,0,0-0.1,0c0,0,0,0-0.1,0l0,0h-0.1l0,0c0,0,0,0-0.1,0l0,0c0,0,0,0-0.1,0h-0.1c0.2,0.3,0.4,0.3,0.6,0.3c4,0,8-7.1,14.6-19 L46.1,14L46.1,14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -443.4042,
    y1: 4.7391,
    x2: -443.212,
    y2: 4.7391,
    gradientTransform: "matrix(72.0226 0 0 99.1613 31934.9922 -445.8823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05A1E6",
      stopOpacity: 0.2471
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05A1E6"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M12.2,14.8L12.2,14.8L12.2,14.8L12.2,14.8C12.2,14.7,12.3,14.7,12.2,14.8C12.3,14.7,12.3,14.7,12.2,14.8 c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0l0,0c0.1,0,0.1,0,0.2-0.1l0,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0.1,0l0,0c0.1,0,0.1,0,0.2-0.1l0,0 c0,0,0,0,0.1,0l0,0c0,0,0,0,0.1,0l0,0h0.1l0,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0.1,0l0,0h0.1c-0.1,0-0.3,0-0.4,0 c-4.5,0-10.6,8.3-13.4,19.1h0.5c0.9-1.7,1.7-3.2,2.5-4.7C4.7,21.3,8.7,16.1,12.2,14.8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M14.7,17.8c0.5-0.5,1-0.9,1.5-1.3c-0.1-0.3-0.2-0.5-0.4-0.7C15.5,16.3,15.1,17,14.7,17.8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M15.1,14.8c0.3,0.2,0.6,0.6,0.8,1c0.1-0.1,0.2-0.2,0.2-0.3C15.8,15.2,15.4,15,15.1,14.8L15.1,14.8L15.1,14.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -440.6499,
    y1: 6.4521,
    x2: -440.6499,
    y2: 6.195,
    gradientTransform: "matrix(49.0511 0 0 73.8222 21621.9121 -443.9029)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#318ED5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#38A7E4"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2.8,29c4.1-7.9,6-12.8,9.4-14.2l0,0C8.7,16.1,4.7,21.3,2.8,29"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M16.1,15.6c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0.2,0.2,0.4,0.4,0.7c0.2-0.1,0.3-0.2,0.5-0.3 C16.5,16,16.3,15.7,16.1,15.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -440.1216,
    y1: 7.6382,
    x2: -440.1216,
    y2: 7.3153,
    gradientTransform: "matrix(45.6036 0 0 57.1283 20079.7773 -403.8785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05A1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05A1E6",
      stopOpacity: 0.549
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M4.6,33.4L4.6,33.4L4.6,33.4L4.6,33.4c-0.1,0-0.1,0-0.2,0l0,0c-0.1,0-0.1,0-0.2,0l0,0c4.1-0.1,6-2.2,7-5.2 c0.7-2.3,1.3-4.2,1.8-5.8c-1.7,2.4-3.5,5.3-5.2,8.6C7,32.6,5.7,33.3,4.6,33.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -441.3849,
    y1: 5.6897,
    x2: -441.3849,
    y2: 5.4973,
    gradientTransform: "matrix(52.5191 0 0 81.0936 23190.8359 -427.9969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1959A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#05A1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#05A1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9176,
    style: {
      stopColor: "#7EC5EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EC5EA"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M4.6,33.4L4.6,33.4C5.7,33.3,7,32.6,7.8,31l0,0c1.7-3.3,3.5-6.2,5.2-8.6l0,0c0.6-2,1.1-3.5,1.7-4.6l0,0 C11.3,21.1,7.8,26.6,4.6,33.4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2.8,29c-0.7,1.4-1.5,2.9-2.4,4.5H2C2.1,31.9,2.4,30.4,2.8,29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -443.4657,
    y1: 4.8291,
    x2: -443.5068,
    y2: 4.6584,
    gradientTransform: "matrix(72.6768 0 0 99.0047 32240.0469 -445.7053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#165096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D82CA"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M13.5,14.4L13.5,14.4L13.5,14.4L13.5,14.4L13.5,14.4c-0.1,0-0.1,0-0.1,0l0,0c0,0,0,0-0.1,0l0,0l0,0l0,0h-0.1 l0,0l0,0l0,0c0,0,0,0-0.1,0l0,0l0,0l0,0c0,0,0,0-0.1,0l0,0l0,0l0,0c-0.1,0-0.1,0-0.2,0.1l0,0l0,0l0,0c0,0,0,0-0.1,0l0,0l0,0l0,0 c0,0,0,0-0.1,0l0,0l0,0l0,0c-0.1,0-0.1,0-0.2,0.1l0,0l0,0l0,0c0,0,0,0-0.1,0l0,0l0,0l0,0c0,0,0,0-0.1,0l0,0l0,0l0,0 C8.8,16.1,6.9,21.1,2.8,29l0,0c-0.4,1.4-0.7,2.9-0.9,4.4l0,0h0.2c0.6,0,0.8,0,1.5,0l0,0l0,0h0.1l0,0l0,0l0,0l0,0l0,0l0,0h0.1h0.3 h0.1l0,0h0.1l0,0c0,0,0.1,0,0.2,0l0,0l0,0l0,0c0,0,0,0,0.1,0l0,0l0,0l0,0c0,0,0,0,0.1,0l0,0c3.2-6.9,6.6-12.3,10.1-15.6l0,0 c0.4-0.9,0.8-1.5,1.2-2l0,0c-0.2-0.4-0.5-0.7-0.8-1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0,0,0,0-0.1,0l0,0l0,0l0,0H15l0,0l0,0l0,0 c0,0,0,0-0.1,0l0,0l0,0l0,0h-0.1l0,0l0,0l0,0h-0.1l0,0l0,0l0,0h-0.1l0,0l0,0l0,0c-0.1,0-0.2,0-0.2,0l0,0l0,0l0,0h-0.1l0,0l0,0l0,0 h-0.1l0,0l0,0l0,0h-0.1l0,0C13.6,14.4,13.6,14.4,13.5,14.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -440.343,
    y1: 8.1906,
    x2: -440.343,
    y2: 8.0362,
    gradientTransform: "matrix(32.7663 0 0 57.2261 14466.4131 -445.855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05A1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    style: {
      stopColor: "#0495D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0495D6"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M36.8,19.1c-0.8,2.5-1.4,4.6-2,6.3l0,0c2.2-3,4.3-6.7,6.3-11l0,0C38.7,15.1,37.5,16.8,36.8,19.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -444.4858,
    y1: 4.7879,
    x2: -444.5454,
    y2: 4.9994,
    gradientTransform: "matrix(60.2691 0 0 96.3231 26830.8828 -447.9932)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38A7E4",
      stopOpacity: 0.3294
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#0E88D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#0E88D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E88D3"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M34.8,32.3c-0.1,0.1-0.2,0.1-0.3,0.2c4.2-1.9,9.2-9.3,11.6-18.5h-0.5C40.1,23.8,38.4,30.4,34.8,32.3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M32.1,31.5c0.9-1.1,1.7-3,2.7-6.1c-1.2,1.6-2.3,3-3.5,4.1l0,0C31.5,30.3,31.8,31,32.1,31.5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.1,31.5c-0.3,0.4-0.6,0.7-1,0.9c-0.1,0-0.2,0.1-0.2,0.1c0.4,0.2,0.8,0.3,1.3,0.4l0,0c0.1,0,0.1,0,0.2,0l0,0 h0.1l0,0h0.1h0.1l0,0h0.1l0,0h0.1l0,0l0,0H33l0,0l0,0h0.1l0,0h0.1l0,0l0,0c0.1,0,0.1,0,0.2,0C33,32.7,32.5,32.2,32.1,31.5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M24.4,32.9c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.7-0.2,1.1-0.3c0.3,0.2,0.6,0.3,1,0.3c0.3,0.1,0.5,0.1,0.8,0.1H24.4 L24.4,32.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M28.5,32.9c1,0,1.7-0.1,2.4-0.4c0.4,0.2,0.8,0.3,1.3,0.4l0,0c0.1,0,0.1,0,0.2,0l0,0h0.1l0,0h0.1H28.5 L28.5,32.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M32.6,32.9L32.6,32.9L32.6,32.9h0.2l0,0h0.1l0,0l0,0H33l0,0l0,0h0.1l0,0h0.1l0,0l0,0c0.1,0,0.1,0,0.2,0l0,0 c0.3,0,0.5,0,0.7,0H32.6L32.6,32.9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M31.2,29.5L31.2,29.5c-0.4,0.4-0.9,0.8-1.3,1.1c-0.2,0.2-0.4,0.3-0.7,0.5c0.2,0.2,0.4,0.4,0.6,0.6 c0.3,0.3,0.6,0.6,1,0.7c0.1,0,0.2-0.1,0.2-0.1c0.4-0.2,0.7-0.5,1-0.9C31.8,31,31.5,30.3,31.2,29.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -445.0851,
    y1: 4.708,
    x2: -445.0851,
    y2: 4.9044,
    gradientTransform: "matrix(70.2816 0 0 98.1105 31320.1445 -447.999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#168CD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#1C87CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#154B8D"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M44.1,14h-2h-0.2l0,0h-0.2l0,0l0,0c-0.1,0-0.3,0-0.4,0l0,0c-0.1,0.1-0.2,0.3-0.2,0.4l0,0c-2,4.3-4.1,8-6.3,11 l0,0c-1,3.1-1.8,5-2.7,6.1l0,0c0.4,0.7,0.8,1.1,1.4,1.3l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0,0,0,0,0.1,0l0,0l0,0l0,0c0,0,0,0,0.1,0l0,0 l0,0l0,0h0.1l0,0l0,0l0,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0.1,0l0,0l0,0l0,0h0.1l0,0l0,0l0,0c0,0,0,0,0.1,0l0,0l0,0l0,0 c0.1,0,0.2-0.1,0.2-0.1l0,0l0,0l0,0c0.1,0,0.2-0.1,0.3-0.2l0,0c3.5-2,5.3-8.5,10.8-18.4l0,0L44.1,14L44.1,14z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M13.7,14.4L13.7,14.4L13.7,14.4h0.1h0.1l0,0H14l0,0c0.1,0,0.2,0,0.2,0.1l0,0h0.1l0,0h0.1l0,0h0.1l0,0 c0,0,0,0,0.1,0l0,0h0.1l0,0c0,0,0,0,0.1,0l0,0l0,0c0.4,0.2,0.7,0.4,1.1,0.8c0.1-0.1,0.3-0.2,0.4-0.3c-0.7-0.5-1.6-0.8-2.5-0.8 C13.9,14.4,13.8,14.4,13.7,14.4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M16.1,15.6c0.2,0.2,0.4,0.4,0.6,0.6c0.2-0.1,0.4-0.3,0.5-0.4c-0.2-0.2-0.5-0.4-0.7-0.6 C16.4,15.3,16.2,15.4,16.1,15.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -437.5342,
    y1: -107.1118,
    x2: -437.3975,
    y2: -107.545,
    gradientTransform: "matrix(32.4594 0 0 -4.2491 14216.4131 -441.6141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97D6EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7033,
    style: {
      stopColor: "#55C1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55C1EA"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M13.7,14.4c0.1,0,0.2,0,0.3,0c1,0,1.8,0.3,2.5,0.8c0.8-0.6,1.7-0.8,3-0.8h-6.2C13.4,14.4,13.5,14.4,13.7,14.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -435.3411,
    y1: -60.6773,
    x2: -435.2087,
    y2: -60.4651,
    gradientTransform: "matrix(26.4722 0 0 -7.484 11541.3789 -438.3798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7ACCEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FB7ED"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M19.5,14.4c-1.3,0-2.2,0.2-3,0.8c0.3,0.2,0.5,0.4,0.7,0.6c1.1-0.7,2.1-1.1,3.2-1.3c0.4-0.1,0.8-0.1,1.2-0.1 H19.5L19.5,14.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -443.4589,
    y1: 5.74,
    x2: -443.4589,
    y2: 5.9738,
    gradientTransform: "matrix(52.0449 0 0 80.6355 23116.123 -447.8545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DA7E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#37ABE7",
      stopOpacity: 0
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M34.8,25.4c0.6-1.7,1.2-3.8,2-6.3c0.7-2.3,2-4,4.3-4.7c0.1-0.1,0.1-0.3,0.2-0.4c-3.8,0.2-5.6,2.2-6.5,5.1 c-1.6,5.1-2.5,8.3-3.5,10.4C32.4,28.4,33.6,27,34.8,25.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsDotnet);
export default __webpack_public_path__ + "static/media/windows-dotnet.eeec4dda458177cfaadf9dfa64437578.svg";
export { ForwardRef as ReactComponent };